export const config = [
  {
    name: '华北',
    regions: ['北京', '天津', '河北', '山西', '内蒙古'],
    color: '#f4b3b3',
    num: 0,
  },
  {
    name: '华东',
    regions: ['上海', '江苏', '浙江', '安徽', '福建', '江西', '山东', '台湾'],
    color: '#e61c4c',
    num: 0,
  },
  {
    name: '东北',
    regions: ['辽宁', '吉林', '黑龙江'],
    color: '#acce22',
    num: 0,
  },
  {
    name: '西北',
    regions: ['陕西', '甘肃', '青海', '宁夏', '新疆'],
    color: '#a79ccc',
    num: 0,
  },
  {
    name: '华南',
    regions: ['广东', '广西', '海南'],
    color: '#a72184',
    num: 0,
  },
  {
    name: '西南',
    regions: ['重庆', '四川', '贵州', '云南', '西藏'],
    color: '#fdd100',
    num: 0,
  },
  {
    name: '华中',
    regions: ['河南', '湖北', '湖南'],
    color: '#56aab7',
    num: 0,
  },
];
export const positionMap = {
  内蒙古: ['70%', '60%'],
  黑龙江: ['50%', '60%'],
  台湾: ['36%', '50%'],
  河北: ['30%', '60%'],
  江苏: ['65%', '50%'],
  江西: ['40%', '50%'],
  陕西: ['60%', '70%'],
  甘肃: ['75%', '75%'],
};
